import type { ColumnDef, VisibilityState } from "@tanstack/react-table";
import type { Project } from "@/app/projects/types";
import { DataTable } from "@/components/custom/table/data-table";
import { DataTableContent } from "@/components/custom/table/data-table-content";
import { DataTablePagination } from "@/components/custom/table/data-table-pagination";
import { DataTableToolbar } from "./data-table-toolbar";

type ProjectsTableProps = {
  data: Project[];
  columns: ColumnDef<Project>[];
  defaultPageSize?: number;
  columnVisibility?: VisibilityState;
  onColumnVisibilityChange?: (
    value: VisibilityState | ((val: VisibilityState) => VisibilityState)
  ) => void;
};

export const ProjectsTable = ({
  data,
  columns,
  defaultPageSize = 10,
  columnVisibility,
  onColumnVisibilityChange,
}: ProjectsTableProps) => (
  <DataTable
    className="my-4 space-y-4"
    columns={columns}
    columnVisibility={columnVisibility}
    data={data}
    defaultPageSize={defaultPageSize}
    getRowId={(row) => row.project_id}
    onColumnVisibilityChange={onColumnVisibilityChange}
  >
    <DataTableToolbar />
    <DataTableContent />
    <DataTablePagination />
  </DataTable>
);
